<template>
  <div oncontextmenu="return false">
    <home1></home1>
    <case></case>
    <assess></assess>
    <user></user>
    <foot></foot>
  </div>
</template>

<script>
import Home1 from './home1'
import Case from './case'
import Assess from './assess'
import User from './user'
import Foot from '../hardProduct/foot'


export default {
  name:'cooperation',
  components:{Home1,Case,Assess,User,Foot},
  mounted(){
    this.$store.state.hardDot = false
    this.$store.state.homeDot = false
    this.$store.state.softDot = false
    this.$store.state.coopDot = true
    this.$store.state.aboutDot = false
  }
}
</script>




// WEBPACK FOOTER //
// src/components/coopera/cooperation.vue